export default {
  selecionaCategoria (state, payload) {
    state.categoriaSelecionadas = payload.valor
  },
  removeCategoria (state, payload) {
    state.categoriaSelecionadas.splice(state.categoriaSelecionadas.indexOf(payload.valor), 1)
    state.categoriaSelecionadas = [...state.categoriaSelecionadas]
  },
  resetarCategorias (state) {
    state.categoriaSelecionadas = []
  }
}



// WEBPACK FOOTER //
// ./src/store/cadastro/mutations.js